import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ButtonComponent } from '../../common/components/button/button.component';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { InactiveCatDialogComponent } from './inactive-cat-dialog/inactive-cat-dialog.component';
import { AdminService } from '../../../services/admin.service';
import { NotificationSnackbarComponent } from '../snackbar/snackbar.component';
import { ErrorNotficationComponent } from '../../../error-notfication/error-notfication.component';
import { LoaderComponent } from '../../common/components/loader/loader.component';

@Component({
  selector: 'app-category-management',
  standalone: true,
  imports: [MatButtonModule, ButtonComponent, MatCardModule, MatFormFieldModule, MatInputModule, FormsModule, MatTabsModule, MatExpansionModule, CommonModule, MatMenuModule, MatIconModule, MatDialogModule, LoaderComponent],
  templateUrl: './category-management.component.html',
  styleUrl: './category-management.component.scss'
})
export class CategoryManagementComponent implements OnInit {
  
  isAddCategoryVisible: boolean = false;
  categories: any = [];
  activeCategories: any = [];
  inactiveCategories: any = [];
  activeCategoriesMaster: any = [];
  inactiveCategoriesMaster: any = [];
  addSubCat: boolean = false;
  categoryName: string = '';
  subCategoryName: string = '';
  submitCatSubCatPostData: any = {};
  searchData: any;
  filteredCategories: any = [];
  isLoading: boolean = false;

  constructor(
    private dialog: MatDialog,
    private adminService: AdminService,
  ) {

  }

  ngOnInit() {
    this.getAllCategories();
  }

  getAllCategories() {
    this.isLoading = true;
    this.adminService.getAllCategories().subscribe((resp:any) => {
      this.isLoading = false;
      let categories = resp.data.map((item:any) => ({
        ...item, isAddSubCategoryVisible: false, isEditing: false,
        sub_categories: item.sub_categories.map((subCat: any) => ({
          ...subCat,
          isEditing: false
        }))
      }));

      this.categories = JSON.parse(JSON.stringify(categories));

      // this.filteredCategories = this.activeCategories;
      
      this.activeCategoriesMaster = categories.filter((item:any) => item.is_active);
      this.activeCategories = JSON.parse(JSON.stringify(this.activeCategoriesMaster));
      this.inactiveCategoriesMaster = categories.filter((item:any) => !item.is_active);
      this.inactiveCategories = JSON.parse(JSON.stringify(this.inactiveCategoriesMaster));
      
    }, error => {
      // console.error('Error getting categories list:', error);
      this.isLoading = false;
      this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
    })
  }

  addCategory() {
    this.isAddCategoryVisible = !this.isAddCategoryVisible;
  }

  // submitCategory() {
  //   this.isCategory = !this.isCategory;
  // }

  addSubCategory(data: any) {
    data.isAddSubCategoryVisible = !data.isAddSubCategoryVisible;
  }

  submitCategoryOrSubCategory(subCategory: any, isCategory: boolean) {
    if (this.subCategoryName.trim() && subCategory) {
      this.submitCatSubCatPostData = {
        name: this.subCategoryName,
        is_parent: isCategory,
        id: subCategory?.id || null
      };
    } else {
      this.submitCatSubCatPostData = {
        name: this.categoryName,
        is_parent: isCategory,
        id: 0
      };
    }

    if(this.submitCatSubCatPostData.name == '') {
      // alert('please enter valid category');
      if (isCategory) {
        this.openSnackbar('Please enter valid category', 'An error occurred', 'error-snackbar');
      } else {
        this.openSnackbar('Please enter valid Sub Category', 'An error occurred', 'error-snackbar');
      }
      return;
    }

    this.isLoading = true;
    this.adminService.submitSubCategory(this.submitCatSubCatPostData).subscribe((resp:any) => {
      this.isLoading = false;
      if (isCategory) {
        this.openSnackbar("Category added successfully", 'Submitted Successfully', 'success-snackbar');
      } else {
        this.openSnackbar("Sub Category added successfully", 'Submitted Successfully', 'success-snackbar');
      }

      const newCategory = {
        id: resp.id || Date.now(),
        name: this.subCategoryName || this.categoryName
      };
      if (isCategory) {
        this.activeCategories = [newCategory, ...this.activeCategories];
        this.categoryName = '';
        this.isAddCategoryVisible = false;
        this.getAllCategories();
      } else {
        subCategory.sub_categories.push(newCategory);
        this.subCategoryName = '';
        subCategory.isAddSubCategoryVisible = false;
        this.getAllCategories();
      }
    }, error => {
        // this.categoryName = '';
        // this.subCategoryName = '';
        this.isLoading = false;
        this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
        subCategory.isAddSubCategoryVisible = false;
    })

  }

  submitExistingCategory(data: any, catName: any) {
    let catObj = this.categories.find((item:any) =>  (data.id === item.id));
  
    
    if (catObj.name !== catName.value) {
     
      const postData = {
        is_active: data.is_active,
        name: catName.value
      }
      this.isLoading = true;
      this.adminService.updateCategory(data.id, postData).subscribe((resp:any) => {
        this.isLoading = false;
        this.openSnackbar("Updated Category successfully", 'Updated Successfully', 'success-snackbar');
        this.getAllCategories();
      }, (error) => {
        this.isLoading = false;
        this.getAllCategories();
        this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
      })
      data.isEditing = false;
    } else {
      data.isEditing = false;
    }
  }

  closeNewCategoryInput(data: any) {
    let catObj = this.categories.find((item:any) =>  (data.id === item.id));
    data.isEditing = false;
    data.name = catObj.name;
  }

  closeSubCatInput(cat:any, subCat:any) {
    let catObj = this.categories.find((item:any) => (cat.id === item.id));
    let subCatObj = catObj.sub_categories.find((item:any) => (subCat.id === item.id));
    subCat.isEditing = false;
    subCat.name = subCatObj.name;
  }

  submitExistingSubCategory(activeCat: any, subCat: any, subCatName: any) {
    let catObj = this.categories.find((item:any) => (activeCat.id === item.id));
    let subCatObj = catObj.sub_categories.find((item:any) => (subCat.id === item.id));
    if (subCatObj.name !== subCatName.value) {
      const postData = {
        is_active: null,
        name: subCatName.value
      }
      this.isLoading = true;
      this.adminService.updateCategory(subCat.id, postData).subscribe((resp:any) => {
        this.isLoading = false;
        this.openSnackbar("Updated Sub Category successfully", 'Updated Successfully', 'success-snackbar');
        this.getAllCategories();
      }, (error) => {
        this.isLoading = false;
        this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
        this.getAllCategories();
      })
      subCat.isEditing = false;
    } else {
      subCat.isEditing = false;
    }

  }

  deleteCategory(category: any) {
    this.isLoading = true;
    this.adminService.deleteCategory(category.id).subscribe((resp:any) => {
      this.isLoading = false;
      this.openSnackbar("Deleted Category successfully", 'Deleted Successfully', 'success-snackbar');
      this.getAllCategories();
      // const categoryIndex = this.activeCategories.findIndex(
      //   (cat: any) => cat.id === category.id
      // );

      // if (categoryIndex !== -1) {
      //   this.activeCategories.splice(categoryIndex, 1);
      // }

    }, (error) => {
      this.isLoading = false;
      this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');

    })
  }

  deleteSubCategory(subCategory: any, parentCategory: any) {
    this.isLoading = true;
    this.adminService.deleteCategory(subCategory.id).subscribe((resp: any) => {
      this.isLoading = false;
        this.openSnackbar("Deleted Sub Category successfully", 'Delete Successfully', 'success-snackbar');
        this.getAllCategories();
        // const subCategoryIndex = parentCategory.sub_categories.findIndex(
        //   (subCat: any) => subCat.id === subCategory.id
        // );
        
        // if (subCategoryIndex !== -1) {
        //   parentCategory.sub_categories.splice(subCategoryIndex, 1);
        // }
        
  
      }, (error) => {
        this.isLoading = false;
        this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
        console.log("Error deleting subcategory:", error);
      }
    );
  }
  
  onSearch(data:any) {
    
    const searchQuery = this.searchData.toLowerCase().trim();

    if (searchQuery) {
      this.activeCategories = this.activeCategoriesMaster.filter((cat:any) =>
        cat.name.toLowerCase().includes(searchQuery) || cat.sub_categories.some((sub:any) => sub.name.toLowerCase().includes(searchQuery))
      );
      this.inactiveCategories = this.inactiveCategoriesMaster.filter((cat:any) =>
        cat.name.toLowerCase().includes(searchQuery) || cat.sub_categories.some((sub:any) => sub.name.toLowerCase().includes(searchQuery))
      );
    } else {
      this.getAllCategories();
    }
  }

  clearSearch() {
    this.searchData = '';
    this.getAllCategories();
  }

  onValueChange() {
    if(!this.searchData) {
      this.getAllCategories();
    }
  }

  markActiveInactive(data:any) {
    
    const dialogRef = this.dialog.open(InactiveCatDialogComponent, {
      data: data,
      maxWidth: '472px',
      width: '100%',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result:any) => {
            if (result) {
        // this.activeCategories = this.activeCategories.filter((item:any) => item.is_active);
        // this.inactiveCategories = this.activeCategories.filter((item:any) => !item.is_active);
  
        const postData = {
          is_active: result.is_active ? !result.is_active : true,
          name: null
        }
        this.isLoading = true;
        this.adminService.updateCategory(result.id, postData).subscribe((resp:any) => {
          this.isLoading = false;
          // this.openSnackbar("Updated Category successfully", 'Updated Successfully', 'success-snackbar');
          const snackDialogRef = this.dialog.open(NotificationSnackbarComponent, {
            data: {
              is_active: data.is_active,
              name: data.name
            }
          });
  
          setTimeout(() => {
            snackDialogRef.close();
          }, 2000);
          this.getAllCategories();
        }, (error) => {
          this.isLoading = false;
          this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
        })
        
      

      }
    })
  }

  markActiveCategory(activeCat: any) {

  }

  rename(data:any) {
    data.isEditing = true;
  }

  editSubCategory(data:any) {
    data.isEditing = true;
  }

  closeNewCategorySubCategory(subCategory: any, isCategory: boolean) {
    if (isCategory) {
      this.categoryName = '';
      this.isAddCategoryVisible = false;
    } else {
      this.subCategoryName = '';
      subCategory.isAddSubCategoryVisible = false;
    }
  }

  openSnackbar(message: string, title: string, cssClass: string) {
       const dialogRef = this.dialog.open(ErrorNotficationComponent, {
          data: {
            message: message,
            title: title,
            action_type: 'add',
            cssClass: cssClass
          }
        });
    }

}
